<div class="procceed-inspection p-2 pt-3">
  <div>
    <!-- Dialog title -->
    <div mat-dialog-title>
      <div class="failure-popup-header d-flex justify-content-end">
        <img
          src="assets/icon/cross.svg"
          (click)="onClose()"
          class="cursor-pointer"
          alt="close"
        />
      </div>
    </div>
    <!-- Dialog content -->
    <div class="row scroll">
      <div class="col-12 text-center">
        <img
          src="assets/icon/insurance.svg"
          class="insurance-icon"
          alt="close"
        />
      </div>
      <div class="col-12 text-center my-2">
        <div class="premium-payable-group p-2">
          <p class="total-premium-payable-text text-light-blue">
            Total Premium Payable
          </p>
          <p class="total-premium-payable-amount text-light-blue">
            &#8377;
            {{ quotesData[0]?.premium_details?.gross_premium | number : "2." }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <div class="proposal-number-group d-flex justify-content-between">
          <span class="proposal-number-text">Proposal Number</span>
          <span class="proposal-number-id">{{ proposalNumber }}</span>
        </div>
      </div>
      <div class="col-12">
        <button
          class="submit-btn inspection-btn mt-2"
          type="submit"
          (click)="loader ? null : proceedToPayment()"
        >
          <span *ngIf="!quoteData?.is_breakin"
            ><img
              src="assets/gif/button-loader.gif"
              alt="close"
              class="loader me-2"
              *ngIf="loader"
            />Proceed for Payment</span
          >
          <span *ngIf="quoteData?.is_breakin"
            ><img
              src="assets/gif/button-loader.gif"
              alt="close"
              class="loader me-2"
              *ngIf="loader"
            />Proceed for Inspection</span
          >
        </button>
      </div>
      <div class="col-12 mt-2">
        <div class="communication-group d-flex justify-content-between">
          <div
            class="share-group light-blue d-flex justify-content-center me-2"
            (click)="share()"
            *ngIf="isCommunicationGroup"
          >
            <img src="assets/icon/share.svg" class="share-icon" />
            <p class="share-text text-light-blue">Share</p>
          </div>
          <div
            class="download-group light-green justify-content-center d-flex"
            [ngClass]="{ 'download-group-after-share': !isCommunicationGroup }"
            (click)="downloadPremiumBreakup()"
            *ngIf="!downloadLoader"
          >
            <img src="assets/icon/download.svg" class="download-icon" />
            <p class="download-text text-light-green">Download</p>
          </div>
          <div
            class="download-group light-green justify-content-center d-flex"
            [ngClass]="{ 'download-group-after-share': !isCommunicationGroup }"
            *ngIf="downloadLoader"
          >
            <img
              class="downloadloader"
              src="assets/gif/downloadLoader.gif"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="!isCommunicationGroup">
        <div class="communication-group my-2">
          <span class="communication-mode-text">
            Select type of communication mode
          </span>
        </div>
        <div class="communication-group d-flex justify-content-between">
          <div
            class="whatsapp-group light-green me-2"
            [ngClass]="{ 'whatsapp-border': isActiveIcon == 'whatsapp' }"
          >
            <!-- (click)="communication('whatsapp')" -->
            <img src="assets/icon/whatsapp.svg" class="whatsapp-icon" />
          </div>
          <div
            class="sms-group light-blue me-2"
            [ngClass]="{ 'sms-border': isActiveIcon == 'sms' }"
            (click)="communication('sms')"
          >
            <img src="assets/icon/sms.svg" class="sms-icon" />
          </div>
          <div
            class="mail-group light-blue"
            [ngClass]="{ 'mail-border': isActiveIcon == 'mail' }"
            (click)="communication('mail')"
          >
            <img src="assets/icon/mail.svg" class="mail-icon" />
          </div>
        </div>
      </div>
      <form [formGroup]="shareQuotationForm" (ngSubmit)="shareQuotes()">
        <div class="col-12 my-1" *ngIf="isCommunicationField">
          <mat-form-field
            appearance="outline"
            class="registration-number communication-input-field"
            *ngIf="isActiveIcon == 'whatsapp'"
          >
            <mat-label>Enter Whatsapp Number</mat-label>
            <input
              matInput
              maxlength="10"
              appNumbersOnly
              formControlName="whatsApp_number"
            />
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="registration-number communication-input-field"
            *ngIf="isActiveIcon == 'sms'"
          >
            <mat-label>Enter Mobile Number</mat-label>
            <input
              matInput
              maxlength="10"
              appNumbersOnly
              formControlName="contact_number"
            />
            <mat-error
              *ngIf="
                shareQuotationForm.get('contact_number')?.hasError('pattern')
              "
            >
              Invalid contact number
            </mat-error>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="registration-number communication-input-field"
            *ngIf="isActiveIcon == 'mail'"
          >
            <mat-label>Enter Email Id</mat-label>
            <input matInput formControlName="email" appNotAllowDot />
            <mat-error
              *ngIf="shareQuotationForm.get('email')?.hasError('pattern')"
            >
              Invalid email address
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12" *ngIf="isCommunicationField">
          <button
            class="submit-btn inspection-btn send-btn"
            type="submit"
            [disabled]="shareQuotationForm.invalid"
          >
            Send
          </button>
          <img
            class="loader send-loader"
            src="assets/gif/button-loader.gif"
            alt=""
            *ngIf="sendLoader"
          />
        </div>
      </form>
      <div class="col-lg-12 text-center" *ngIf="failureMessage">
        <span class="failureMessage">{{ message }}</span>
      </div>
    </div>
  </div>
</div>
